import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Recobra la calma interior que mereces', 'Sin alterar tu rutina diaria', 'Ejercicios simples y prácticos', 'Afirmaciones que resuenan en tu interior', 'Guía paso a paso durante 30 días', 'Acceso inmediato y de por vida'];
  return <section className="py-20 bg-[#1a3a52] text-[#f5f1e8]" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          <div data-id="element-4">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-5">
              Este es el momento de tomar el control
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-6">
              No dejes que la ansiedad siga dictando tus días. Todo comienza con
              una sola pausa y declarar desde tu interior creyendo en cada
              palabra sobre tu vida.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-7">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start space-x-3" data-id="element-8">
                  <CheckCircle2 className="w-6 h-6 text-[#d4af37] flex-shrink-0" data-id="element-9" />
                  <span className="text-gray-200" data-id="element-10">{benefit}</span>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-11">
            <div className="absolute inset-0 bg-[#d4af37] rounded-2xl transform rotate-3 opacity-20" data-id="element-12"></div>
            <div className="relative bg-[#132c3f] p-8 rounded-2xl border border-[#d4af37]/30" data-id="element-13">
              <h3 className="text-2xl font-serif font-bold text-[#d4af37] mb-4" data-id="element-14">
                Lo que recibirás
              </h3>
              <ul className="space-y-4" data-id="element-15">
                <li className="flex justify-between items-center border-b border-gray-700 pb-4" data-id="element-16">
                  <span data-id="element-17">Guía Digital Completa (PDF)</span>
                  <span className="font-semibold text-[#d4af37]" data-id="element-18">Incluido</span>
                </li>
                <li className="flex justify-between items-center border-b border-gray-700 pb-4" data-id="element-19">
                  <span data-id="element-20">Plan de 30 Días</span>
                  <span className="font-semibold text-[#d4af37]" data-id="element-21">Incluido</span>
                </li>
                <li className="flex justify-between items-center border-b border-gray-700 pb-4" data-id="element-22">
                  <span data-id="element-23">Colección de Afirmaciones</span>
                  <span className="font-semibold text-[#d4af37]" data-id="element-24">Incluido</span>
                </li>
                <li className="flex justify-between items-center pt-2" data-id="element-25">
                  <span className="text-lg font-medium" data-id="element-26">Precio Regular</span>
                  <span className="text-xl font-bold line-through text-gray-500" data-id="element-27">
                    $19.99 USD
                  </span>
                </li>
              </ul>
              <div className="mt-8 text-center" data-id="element-28">
                <div className="inline-block bg-[#d4af37] text-[#1a3a52] px-4 py-1 rounded-full text-sm font-bold mb-3" data-id="element-29">
                  ¡OFERTA ESPECIAL!
                </div>
                <p className="text-sm text-gray-400 mb-2" data-id="element-30">
                  Precio de oferta hoy
                </p>
                <p className="text-5xl font-bold text-white mb-2" data-id="element-31">$6.39 USD</p>
                <p className="text-sm text-[#d4af37]" data-id="element-32">Ahorra más del 68%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}